import React from 'react';
import { Card, CardHeader, CardTitle, CardBody, Row, Col } from 'reactstrap';

function Help() {
  return (
    <div className='content'>
      <Row>
        <Col>
          <Card className='card-user'>
            <CardHeader>
              <Row>
                <Col sm={8}>
                  <CardTitle tag='h4'>Ayuda</CardTitle>
                </Col>
                <Col sm={4}></Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Datos personales</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_datos_personales.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Alta de OOSS</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_alta_de_ooss.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Modificar forma de pago</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_Modificar_forma_de_pago.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Alta de consultorio</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_alta_de_consultorio.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Renovación de consultorio</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_renovacion_de_consultorio.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Baja de consultorio</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_baja_de_consultorio.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Help;
